(function() {
    const offset = 50;

    function getSlugFromHash(hash) {
        if (!hash || hash === '#') return '';
        const rawSlug = hash.charAt(0) === '#' ? hash.substring(1) : hash;

        try {
            return decodeURIComponent(rawSlug);
        }
        catch (e) {
            return rawSlug;
        }
    }

    function scrollToAnchorSlug(anchorSlug) {
        if (!anchorSlug) return false;

        const section = document.querySelector('[data-anchor="' + anchorSlug + '"]');
        if (!section || typeof vanillaSmoothie === 'undefined') return false;

        vanillaSmoothie.scrollTo(section.getBoundingClientRect().y + window.scrollY - offset, { duration: 500, easing: 'easeInOutQuad' });
        return true;
    }

    function handleHashScroll() {
        return scrollToAnchorSlug(getSlugFromHash(window.location.hash));
    }

    // On initial load (already works today, but keep it centralized)
    handleHashScroll();

    // When hash changes (e.g. clicking a #link), scroll to matching data-anchor
    window.addEventListener('hashchange', _ => handleHashScroll());

    // Intercept in-page # links so they work with data-anchor targets
    document.addEventListener('click', e => {
        const linkEl = e.target.closest('a[href^="#"]');
        if (!linkEl) return;

        const href = linkEl.getAttribute('href');
        const anchorSlug = getSlugFromHash(href);
        if (!anchorSlug) return;

        // Only handle anchors that exist as data-anchor.
        if (!document.querySelector('[data-anchor="' + anchorSlug + '"]')) return;

        e.preventDefault();

        if (window.location.hash !== '#' + encodeURIComponent(anchorSlug)) {
            history.pushState(null, '', '#' + encodeURIComponent(anchorSlug));
        }

        scrollToAnchorSlug(anchorSlug);
    });
})();